<template>
  <div class="flex flex-col items-center content-center justify-center">
    <div class="w-full max-w-screen-md p-0">
      <ExternalTaskDetail
        v-if="task && ticketTask && ticket"
        :task-id="task"
        :ticket-task-id="ticketTask"
        :ticket-id="ticket"
        :organization="organization"
        :hash="hash"
        :type="type"
        @refresh="refresh($event)"
      />
    </div>
  </div>
</template>
<script>
import ExternalTaskDetail from '@/components/ExternalTaskDetail'
import { decrypt } from '@/repositories/integrations/mobly/services/csExternal/decrypt'
import { MOBLY } from '@/utils/possible-organizations-values'
import { setTheme } from '@/utils/theme'

export default {
  name: 'ExternalTaskDetailView',

  components: {
    ExternalTaskDetail
  },

  data () {
    return {
      task: null,
      ticketTask: null,
      ticket: null,
      organization: null,
      type: 'customer',
      hash: null
    }
  },

  mounted () {
    this.setTask()
  },

  methods: {
    async setTask () {
      try {
        const decrypted = await this.decrypt()
        this.organization = decrypted.organization || MOBLY
        this.type = decrypted.type || 'customer'
        setTheme(this.organization)
        this.task = decrypted.task
        this.ticket = decrypted.ticket
        this.ticketTask = decrypted.ticketTask
      } catch (err) {
        this.snackBar.message = 'Não foi possível abrir a página requisitada'
        this.snackBar.show = true
      }
    },

    async decrypt () {
      const hash = this.$route.query.h
      this.hash = encodeURIComponent(hash)
      const organization = this.$route.query.org
      const request = await decrypt({ hash }, organization)
      return request.data
    },

    refresh (params) {
      this.task = null
      this.ticketTask = null
      setTimeout(() => {
        this.setTask()
      }, 500)
    }
  }
}
</script>
